import { Box, Theme } from "@mui/material";
import React, { ReactElement } from "react";
import { SxProps } from "@mui/system";

export type IconWrapperProps = {
  icon: string | React.ComponentType<{ sx?: SxProps<Theme> }> | ReactElement<{ sx?: SxProps<Theme>; alt?: string }>;
  sx?: SxProps<Theme>;
  alt?: string;
  /** Wenn true, wird das Icon für Screenreader ausgeblendet (aria-hidden) */
  screenReaderHidden?: boolean;
};

const IconWrapper = ({ icon, sx = {}, alt = "", screenReaderHidden = false }: IconWrapperProps) => {
  if (typeof icon === "string") {
    return <Box component="img" src={icon} sx={sx} alt={alt} aria-hidden={screenReaderHidden} />;
  }

  let content: React.ReactNode;
  if (React.isValidElement(icon)) {
    content = React.cloneElement(icon, { sx, alt });
  } else {
    const IconComponent = icon;
    content = <IconComponent sx={sx} />;
  }

  return (
    <Box component="span" aria-hidden={screenReaderHidden}>
      {content}
    </Box>
  );
};

export default IconWrapper;
